export default __webpack_public_path__ + "static/media/PST-Forecasting-01.6b830470.jpg";